module.exports = __webpack_public_path__ + "img/picture_04_portada.f9d8161b.png";